if($(".mv-slider").length) {
    var mv = new Swiper('.mv-slider', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        autoplay: { // 自動再生
            delay: 3000, // 1.5秒後に次のスライド
        }
    });
}